module.exports = __webpack_public_path__ + "img/subBan05.60919eff.jpg";